import {
  blue,
  red,
  green,
  purple,
  orange,
  teal,
  pink,
  indigo,
  amber,
  cyan,
  lime,
  deepOrange,
  deepPurple,
  lightBlue,
  lightGreen,
  brown,
  blueGrey,
  yellow,
} from "@mui/material/colors";

export const NBA_LEAGUE_ID = "00";
export const PLAYER_COLORS: string[] = [
  blue[400],
  red[400],
  green[400],
  purple[300],
  orange[400],
  teal[300],
  pink[300],
  indigo[300],
  amber[300],
  cyan[300],
  lime[300],
  deepOrange[200],
  deepPurple[300],
  lightBlue[200],
  lightGreen[200],
  brown[300],
  blueGrey[300],
  yellow[300],
];
export const PORTLAND_TEAM_ID = 1610612757;
export const QUARTERS = ["Q1", "Q2", "Q3", "Q4"];
export const MINUTES = [12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
export const PLAYER_SLOTS = [1, 2, 3, 4, 5];
